const stylesheets = [
  'https://pro.fontawesome.com/releases/v5.9.0/css/all.css',
  'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap'
];

window.addEventListener('load', () => {
  stylesheets.forEach(href => {
    let preloadStyle = document.createElement('link');
    preloadStyle.href = href;
    preloadStyle.rel = 'stylesheet';
    preloadStyle.as = 'style';
    document.head.appendChild(preloadStyle);
  });
});
